import styled from "styled-components";

export const NossasSolucoesPageStyle = styled.div`

`